import React from 'react';
import styled from 'styled-components';
import { media } from '../../utils/styles';
import { rhythm } from '../../utils/typography';
import { BestPeeps } from '../BestPeeps';

const HeroSpacer = styled.div`
  width: ${rhythm(1)};
  ${media.mobile`
    display: none;
  `}
`;

const HomePeeps = styled(BestPeeps)`
  flex: 1;
`;

const HeroContent = styled.div``;
const HeroSection = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  ${media.mobile` flex-direction: column; padding-bottom: 0;`}
`;
const XyzPitch = styled.div`
  flex: 1;
  ${media.mobile`text-align: center;`}
`;

export const HomeHero = () => (
  <HeroContent>
    <HeroSection>
      <XyzPitch>
        <h1>We learn from the bests.</h1>
        <p>We learn what’s possible from the bests and we make it possible for everybody.</p>
        <p>We find the best people at solving any problem, summarize their learnings and share them with you.</p>
      </XyzPitch>
      <HeroSpacer />
      <HomePeeps />
    </HeroSection>
  </HeroContent>
);
